webpackJsonp([1],{

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkAndHideZeroReviewElements;
function checkAndHideZeroReviewElements() {
  var reviewWidgets = document.querySelectorAll('.yotpo-widget-instance[data-yotpo-widget-uuid]:not([data-review-check-complete])');
  reviewWidgets.forEach(function (reviewWidget) {
    var reviewElement = reviewWidget.querySelector('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel');
    if (!reviewElement) return;
    var reviewText = reviewElement.textContent.trim();

    // Mark this widget as checked to prevent future runs
    reviewWidget.setAttribute('data-review-check-complete', 'true');
    if (reviewText === '0 Reviews') {
      reviewWidget.remove();
    }
  });
}

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Handles add to bag button for PLP's (Supported only by favorites and BI best sellers)
 *
 * @module plpAddToBag
 */



var PLUGIN_NAME = 'plpAddToBag';
var addToBag = function addToBag($el) {
  var productCode = $el.data('code');
  var $favSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + productCode + '-fav-size-value');
  var swatchName = 'product-color-' + productCode;
  var radioBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name=\'' + swatchName + '\']:checked');
  var saveSizeToDb = $el.data('canSaveSize');
  if (radioBtn && radioBtn.length) {
    productCode = radioBtn.closest('.js-plp-swatch').data('code');
    saveSizeToDb = false;
    if ($favSize.length) {
      if ($el.data('code') === productCode) {
        $favSize.text('Size :' + $favSize.data('size'));
      } else {
        $favSize.text('Save your size');
      }
    }
  }
  var isOneSize = $el.data('isOneSize');
  if (!productCode) {
    return;
  }
  var productSize = '';
  if (isOneSize) {
    productSize = 'all';
  } else {
    var $selectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + productCode + '-fav-size-value');
    if (!$selectedSize.length) {
      openSizeMenu($el, productCode, saveSizeToDb);
      return;
    } else {
      productSize = $selectedSize.data('size');
      if ($selectedSize.data('isFavSizeOos')) {
        openSizeMenu($el, productCode, saveSizeToDb);
        return;
      }
    }
  }
  if (productSize === undefined || productSize === '') {
    return;
  }
  var data = {
    productCode: productCode,
    size: productSize,
    sectionURL: $el.data('sectionUrl') || window.rcProps.sectionUrl,
    sessionID: window.rcProps.sessionId,
    count: 1,
    csrfHash: window.rcProps.csrfHash,
    focusID: 'addToBag_' + $el.data('code')
  };
  addProductWithData(data);
};
function openSizeMenu($el, productCode, saveSizeToDb) {
  var $sizeEl = $el.closest('.js-plp-container').find('.plp__select-size').find('.js-select-size');
  var $size = $sizeEl.clone();
  $size.insertAfter($sizeEl);
  $sizeEl.remove();
  var sizePath = window.rcProps.sizeMarkupUri + '?code=' + productCode;
  $size.attr('data-size-path', sizePath);
  if (saveSizeToDb) {
    var updateSizePath = window.rcProps.updateProductSizeUri + '?code=' + productCode;
    $size.attr('update-size-path', updateSizePath);
  }
  $size.attr('code', productCode);
  var $sizeTrigger = $el.closest('.js-plp-container').find('.plp__select-size').find('.js-select-size-trigger');
  if ($sizeTrigger.length) {
    $sizeTrigger.data('addToBag', 'true');
    $sizeTrigger.data('code', productCode);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-select-size').data('saveSize', saveSizeToDb).sizeSelection();
    $sizeTrigger.click();
  }
}

/**
 * Add To Bag Functionality for PLP (Supported on Favorites/BI Best Seller Page atm)
 *
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
function plpAddToBag(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  $el.on('click', function (e) {
    e.preventDefault();
    addToBag($el);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, plpAddToBag);

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

$(document).ready(function () {
  // Prevent Enter key from closing the dropdown
  $('.js-search-designer, .js-enterable.checkbox__input').keydown(function (event) {
    if (event.keyCode === 13) {
      // Enter key
      event.preventDefault(); // Prevent default action (form submission)
      event.stopPropagation(); // Stop the event from propagating
    }
  });

  // Initialize the selected designers from the URL
  var selectedDesigners = getSelectedDesignersFromUrl();
  selectedDesigners.forEach(function (designer) {
    $(".js-enterable.checkbox__input[value=\"".concat(designer, "\"]")).prop('checked', true);
  });
  updateSelectedDesignersUI(selectedDesigners);

  // Designer Filter Search and Selection
  $('.js-search-designer').keyup(function () {
    // Add/remove class to list parent based on input value
    var $input = $(this);
    var $list = $('.filters__designer-list');
    var isABTest920 = $input.data('ab920');
    console.log(isABTest920);
    if (isABTest920) {
      if ($input.val().trim() !== '') {
        $list.addClass('has-value');
      } else {
        $list.removeClass('has-value');
      }
    }

    // Directly use the user's input for the search, including symbols.
    // We escape special regex characters to prevent unexpected behavior.
    var value = $(this).val().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    var numOfVisibleResults = 0;
    $('.filters__designer-list li').each(function () {
      var span = $(this).find('span');
      var originalText = span.text();
      // RegExp object for case-insensitive matching
      var regex = new RegExp(value, 'gi');
      if (originalText.search(regex) > -1) {
        // Replace the matched text with a bold version for highlighting
        var boldedText = originalText.replace(regex, function (match) {
          return '<strong>' + match + '</strong>';
        });
        span.html(boldedText);
        $(this).removeClass('u-hide');
        numOfVisibleResults++;
      } else {
        // If there's no match, simply show the original text without any modification
        span.html(originalText);
        $(this).addClass('u-hide');
      }
    });
    if (numOfVisibleResults > 0) {
      $('.js-filter-search-no-results').hide().empty();
    } else {
      $('.js-filter-search-no-results').html('No results found.').show();
    }
  });
  $('.js-enterable.checkbox__input').change(function () {
    var selectedDesigners = [];
    $('.js-enterable.checkbox__input:checked').each(function () {
      selectedDesigners.push($(this).val());
    });
    updateSelectedDesignersUI(selectedDesigners);
    updateUrlParameters(selectedDesigners);
  });
  $(document).on('click', '.js-remove-designer-selection', function () {
    var designerId = $(this).data('designer-id');
    $(".js-enterable.checkbox__input[value=\"".concat(designerId, "\"]")).prop('checked', false).trigger('change');
  });

  // Function to focus on the previous button
  function focusOnPreviousButton() {
    // Get the previous button element
    var previousButton = $('.selected-designers .js-filter-button:last');

    // Check if a previous button exists
    if (previousButton.length > 0) {
      // Set focus on the previous button
      previousButton[0].focus();
    }
  }

  // Function to handle keydown event
  function handleKeydown(event) {
    if (event.keyCode === 13 || event.keyCode === 32) {
      var designerId = $(this).find('.js-remove-designer-selection').data('designer-id');
      $(".js-enterable.checkbox__input[value=\"".concat(designerId, "\"]")).prop('checked', false).trigger('change');
      focusOnPreviousButton();
      return false; // Prevent default action
    }
  }

  // Attach keydown event listener to dynamically inserted buttons
  $('.selected-designers').on('keydown', '.js-filter-button', handleKeydown);
});
function getUrlParameter(name) {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  return results === null ? null : decodeURIComponent(results[1]) || null;
}
function getSelectedDesignersFromUrl() {
  var designers = [];
  var searchParams = new URLSearchParams(window.location.search);
  searchParams.forEach(function (value, key) {
    if (key === 'designer') {
      designers.push(value);
    }
  });
  return designers;
}
function updateUrlParameters(designers) {
  var url = new URL(window.location.href);
  url.searchParams["delete"]('designer');
  designers.forEach(function (designer) {
    url.searchParams.append('designer', designer);
  });
  window.history.pushState({}, '', url);
}
function updateSelectedDesignersUI(selectedDesigners) {
  var designerButtons = selectedDesigners.map(function (designer) {
    return "\n        <button \n            data-designer-id=\"".concat(designer, "\"\n            class=\"pill-button pill-button--light-grey u-margin-r--lg u-margin-b--lg js-filter-button\">\n            <span class=\"u-screen-reader\">Remove </span>").concat(designer, "<span class=\"u-screen-reader\"> from filter </span>\n            <span class=\"u-pointer icon icon--x icon--xs u-margin-l--sm js-remove-designer-selection\" data-designer-id=\"").concat(designer, "\">\n                <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                    <path d=\"M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28\n                        4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8\n                        9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z\">\n                    </path>\n                </svg>\n            </span>\n        </button>\n    ");
  }).join('');
  if (selectedDesigners.length > 0) {
    $('.selected-designers').html(designerButtons);
  } else {
    $('.selected-designers').html('');
  }
}

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * Handles tab functionality for Loyalty Favorites LP
 *
 * @module loyaltyFavorites
 */


__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  // Should only run if we're on a loyalty favorites LP
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.loyalty-favorites').length) {
    var waitForFirstRowImages = function waitForFirstRowImages() {
      var $images = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-favorites-content .n-block-grid--5 li .product-image');
      if ($images.length <= 5) {
        return hideSkeletonAndShowProducts();
      }
      // Select first 5 above the fold images
      var $firstRowImages = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-favorites-content .n-block-grid--5 li:lt(5) img');
      var imagesLoaded = 0;
      $firstRowImages.each(function () {
        if (this.complete) {
          // Check if image is already cached
          imagesLoaded++;
          if (imagesLoaded === $firstRowImages.length) {
            hideSkeletonAndShowProducts();
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).on('load', function () {
            imagesLoaded++;
            if (imagesLoaded === $firstRowImages.length) {
              hideSkeletonAndShowProducts();
            }
          });
        }
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).on('error', function () {
          imagesLoaded++;
          if (imagesLoaded === $firstRowImages.length) {
            hideSkeletonAndShowProducts();
          }
        });
      });

      // Handle case where there are no images in the first row
      if ($firstRowImages.length === 0) {
        hideSkeletonAndShowProducts();
      }
    };
    var hideSkeletonAndShowProducts = function hideSkeletonAndShowProducts() {
      $loadingSkeleton.addClass('u-hide');
      $products.removeClass('u-hide').addClass('loaded');
      if (typeof window.bindHeartEvent === 'function') {
        window.bindHeartEvent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-favorites-content .js-favorite-button'));
      }
    };
    var $tabs = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.loyalty-favorites__tabs');
    var $content = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-favorites-content');
    var $tabAlert = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loyalty-tab-alert');
    var $products = $content.find('.loyalty-favorites__products');
    var $loadingSkeleton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#loading-skeleton');
    var ACTIVE_CLASS = 'tabs__link--active';
    $tabs.on('click', '[data-tab]', function () {
      var tab = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('tab');
      var $clickedTab = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.loyalty-favorites__tab');
      if ($clickedTab.hasClass(ACTIVE_CLASS)) {
        return;
      }
      $loadingSkeleton.removeClass('u-hide');
      $products.removeClass('loaded').addClass('u-hide');
      $tabs.find('.loyalty-favorites__tab').removeClass(ACTIVE_CLASS).attr('aria-selected', 'false');
      $clickedTab.addClass(ACTIVE_CLASS).attr('aria-selected', 'true');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        url: "ajax/".concat(tab, ".jsp"),
        dataType: 'html',
        success: function success(html) {
          $products.html(html);
          waitForFirstRowImages();
          $products.find('.js-lazy-image').lazy();
          if (tab === 'vip') {
            tab = tab.toUpperCase();
          }
          $tabAlert.text("".concat(tab, " tier product listing loaded"));
        },
        error: function error(err) {
          console.error("Error loading Loyalty Favorites HTML content", err);
        }
      });
    });
  }
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(2);
/**
 * Handles notify me button for PLP's (Supported only by favorites and BI best sellers)
 *
 * @module plpNotifyMe
 */



var PLUGIN_NAME = 'plpNotifyMe';
var notifyMe = function notifyMe($el) {
  var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
    code: $el.data('code'),
    sizeSelected: $el.data("sizeSelected")
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: window.rcProps.backInStockSpecialOrderHref,
    data: data,
    triggerOpen: true,
    onComplete: function onComplete() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-progressive-button').progressiveButton();
    }
  });
};

/**
 * Notify Me Functionality for PLP (Supported on Favorites/BI Best Seller Page atm)
 *
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
function plpNotifyMe(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  $el.on('click', function (e) {
    e.preventDefault();
    notifyMe($el);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, plpNotifyMe);

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_throttle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(176);
/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module plpLazyLoad
 */






var PLUGIN_NAME = 'plpLazyLoad';
var DEFAULTS = {
  sessionName: '',
  loadAfterCallback: function loadAfterCallback() {}
};

/**
 * This will check if current Session exists
 * If not, create a new Session Storage and sets the new data into the Session Storage
 * If Session storage already has a value, delete that current value
 * and then set it with the new result value
 */
var setSessionData = function setSessionData(result, lazyLoadUrl, sessionName) {
  var plpSessionData = sessionStorage.getItem(sessionName);
  plpSessionData = JSON.parse(plpSessionData) || [];
  var plpSessionDataJSON = {
    currentUrl: window.location.href,
    plpData: result,
    lazyLoadUrl: lazyLoadUrl
  };

  // only allow 1 session data
  // overwrites the data if there's more than 1 data set
  if (plpSessionData.length > 0) {
    plpSessionData.shift();
  }
  plpSessionData.push(plpSessionDataJSON);
  try {
    sessionStorage.setItem(sessionName, JSON.stringify(plpSessionData));
  } catch (e) {
    console.warn("session storage error:", e);
  }
};

/**
 * Misc. cleanup after appending PLP results
 * @param  {jQuery} $el - $el
 */
var plpAppendCleanup = function plpAppendCleanup($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = arguments.length > 2 ? arguments[2] : undefined;
  var lazyAnimation = arguments.length > 3 ? arguments[3] : undefined;
  $el.parent().css('min-height', '');
  $el.append(result);
  options.loadAfterCallback();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off("scroll.plp-lazy-load");
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination-alternative').show();
  if (lazyAnimation) {
    lazyAnimation.hide();
  }
};

/**
 * Initializes lazy loading for plp
 * @param  {jQuery} $el - The ul container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options*
 */
var lazyLoadPlp = function lazyLoadPlp($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
  var lazyAnimation = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(progressBarHTML());
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: options.lazyLoadUrl,
    cache: false,
    success: function success(result) {
      setSessionData(result, options.lazyLoadUrl, options.sessionName);
      plpAppendCleanup($el, options, result, lazyAnimation);
      setupYotpoObserver();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* checkAndHideZeroReviewElements */])();
    }
  });
  $window.on("scroll.plp-lazy-load", __WEBPACK_IMPORTED_MODULE_3_lodash_throttle___default()(function () {
    var windowHeight = $window.height();
    var scrollPosY = $window.scrollTop() + windowHeight;
    var targetTop = $el.offset().top;
    if (scrollPosY >= targetTop) {
      $el.after(lazyAnimation);
      $window.off("scroll.plp-lazy-load");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination-alternative').hide();
    }
  }, 10));
};
var progressBarHTML = function progressBarHTML() {
  return "<div id=\"js-trigger-load-plp\" class=\"u-padding-b--xl\">\n      <div class=\"progress-bar__lazy u-margin--center\">\n        <div class=\"u-padding-a--xl\">\n          <div class=\"progress-bar progress-bar--dark\">\n            <div class=\"u-screen-reader\">\n              Products are loading\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>";
};
var loadYotpoRatings = function loadYotpoRatings(productEl) {
  if (window.yotpoWidgetsContainer && window.yotpoWidgetsContainer.initWidgets) {
    window.yotpoWidgetsContainer.initWidgets(false);
    if (productEl.dataset.yotpoElementUninitialized === 'true') {
      productEl.classList.add('yotpo-widget-instance');
      productEl.removeAttribute('data-yotpo-element-uninitialized');
    }
  } else {
    console.warn('Yotpo library not found or not ready. Check if script has loaded.');
  }
};
var setupYotpoObserver = function setupYotpoObserver() {
  if ('IntersectionObserver' in window) {
    var options = {
      root: null,
      rootMargin: '0px 0px 1400px 0px',
      threshold: 0
    };
    var observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var productElement = entry.target;
          var productId = productElement.dataset.yotpoProductId;
          if (productId) {
            loadYotpoRatings(productElement);
          }
          // Prevent observation when user scrolls back up/down
          observer.unobserve(productElement);
        }
      });
    }, options);
    document.querySelectorAll('.yotpo-widget-instance:not([data-yotpo-element-loaded="true"])').forEach(function (widget) {
      observer.observe(widget);
      widget.classList.remove('yotpo-widget-instance');
      widget.setAttribute('data-yotpo-element-uninitialized', 'true');
    });
  } else {
    // IntersectionObserver unsupported, use old code
    if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets !== 'undefined') {
      yotpoWidgetsContainer.initWidgets(false);
    }
  }
};

/**
 * Initializes plpLazyLoad.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the plpLazyLoad
 * @see DEFAULTS
 */
function plpLazyLoad(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var sessionArray = JSON.parse(sessionStorage.getItem(options.sessionName)) || [];
  // Checks if there's an object with current URL already
  var getObjFromPlpSessionData = sessionArray.filter(function (obj) {
    return obj.currentUrl === window.location.href && obj.lazyLoadUrl === options.lazyLoadUrl;
  });
  if (getObjFromPlpSessionData.length > 0) {
    plpAppendCleanup($el, opts, getObjFromPlpSessionData[0].plpData);
  } else {
    lazyLoadPlp($el, opts);
  }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, plpLazyLoad);

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export SS_MENU_CLASS */
/* unused harmony export SS_TRIGGER_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__ = __webpack_require__(13);
/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module sizeSelection
 */





var PLUGIN_NAME = 'sizeSelection';
var SS_MENU_CLASS = '.js-select-size-menu';
var SS_TRIGGER_CLASS = '.js-select-size-trigger';
var DEFAULTS = {
  animationSpeed: 100
};

/**
 * Prevent Hash
 * @param  {event} interaction event
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 */
var preventHash = function preventHash(evt, $saveSizeTrigger) {
  if (__WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ENTER' || evt.type == 'click') {
    if ($saveSizeTrigger.attr('href') == "#") {
      evt.preventDefault();
    }
  }
};
var setLoading = function setLoading($el) {
  $el.closest('.js-product-info-block').append(progressBarHTML());
};
var removeLoading = function removeLoading($el) {
  $el.closest('.js-product-info-block').find('.plp__size-loading').remove();
};
var progressBarHTML = function progressBarHTML() {
  return "<div class=\"plp__size-loading\">\n        <div class=\"u-padding-a--xl\">\n                <div class=\"progress-bar progress-bar--dark\">\n                    <div class=\"u-screen-reader\">\n                        Content is Loading\n                    </div>\n                </div>\n            </div>\n        </div>";
};
var openSizes = function openSizes($el, $saveSizeTrigger, $saveSizeMenu, opts) {
  $el.addClass('ss-is-open');
  $saveSizeMenu.css({
    display: 'block',
    opacity: 0
  }).stop().animate({
    opacity: 1
  }, opts.animateSpeed, function () {});
  setClickCloseListener($el, $saveSizeTrigger, $saveSizeMenu, opts);
};
var closeSizes = function closeSizes($el, $saveSizeMenu, opts) {
  $el.removeClass('ss-is-open');
  $el.find('input[type=radio][name=fav-size-selection]').off('change.size');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('click.close');
  $saveSizeMenu.stop().animate({
    opacity: 0
  }, opts.animateSpeed / 2, function () {
    $saveSizeMenu.css('display', 'none');
  });
};
var showConfirmation = function showConfirmation($saveSizeTrigger, opts, hasError) {
  var saveSizeConfirmPath = opts.saveSizeConfirmPath;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    url: "".concat(saveSizeConfirmPath).concat(hasError),
    type: 'notification',
    triggerOpen: true,
    returnFocus: $saveSizeTrigger
  });
};
var updateSizeCopy = function updateSizeCopy($el, $saveSizeTrigger, sizeValue, opts) {
  var code = opts.code;
  if ($saveSizeTrigger.data('code')) {
    code = $saveSizeTrigger.data('code');
  }
  var hideClass = opts.hideCopy ? "class=\"u-hide\"" : "";
  $saveSizeTrigger.html("<span id=\"".concat(code, "-fav-size-value\" data-size=\"").concat(sizeValue, "\" ").concat(hideClass, ">Size: ").concat(sizeValue, "</span>"));
  var $soldOut = $el.find('.js-saved-size-sold-out');
  if ($soldOut.length) {
    $soldOut.hide();
  }
};
var keydownHandler = function keydownHandler($el, evt, $saveSizeTrigger, opts, isKey) {
  var isTab = __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'TAB';
  var isShiftTab = __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'SHIFT_TAB';
  var isEnter = __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ENTER';
  var isNextArrows = __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ARROWRIGHT' || __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ARROWDOWN';
  var isPrevArrows = __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ARROWLEFT' || __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ARROWUP';
  var sizeHaveFocus = $el.find('input[type=radio]').is(":focus");
  if (isEnter) {
    if (!$el.hasClass('ss-is-open')) {
      evt.preventDefault();
      getSizes($el, $saveSizeTrigger, opts, isKey);
    }
    if (sizeHaveFocus) {
      var sizeIsChecked = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.target).is(':checked');
      var sizeValue = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(evt.target).prop('value');
      if (!sizeIsChecked) {
        updateSizeCopy($el, $saveSizeTrigger, sizeValue, opts);
      }
      var $saveSizeMenu = $el.find(SS_MENU_CLASS);
      updateSizeToDb($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue);
    }
  }
  if ((isNextArrows || isPrevArrows) && sizeHaveFocus) {
    var _$saveSizeMenu = $el.find(SS_MENU_CLASS);
    setUpdateSizeListener($el, $saveSizeTrigger, _$saveSizeMenu, isKey, opts);
  }
  if ((isTab || isShiftTab) && sizeHaveFocus) {
    var _$saveSizeMenu2 = $el.find(SS_MENU_CLASS);
    closeSizes($el, _$saveSizeMenu2, opts);
  }
};
var setUpdateSizeListener = function setUpdateSizeListener($el, $saveSizeTrigger, $saveSizeMenu, isKey, opts) {
  $el.find('input[type=radio]').on('change.size', function (evt) {
    var sizeValue = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop('value');
    var isOneLeft = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('isOneLeft');
    updateSizeCopy($el, $saveSizeTrigger, sizeValue, opts);
    var addToBag = opts.addToBag,
      code = opts.code;
    var $soldOut = $el.find('.js-saved-size-sold-out');
    var $oneLeft = $el.find('.js-saved-size-one-left');
    if ($soldOut.length) {
      $soldOut.hide();
    }
    if (isOneLeft !== undefined && $oneLeft.length) {
      if (isOneLeft) {
        $oneLeft.show();
      } else {
        $oneLeft.hide();
      }
    }
    if (!isKey) {
      updateSizeToDb($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue);
    }
    if (addToBag === 'true') {
      var $addToBag = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBag_".concat(code));
      if ($addToBag.length) {
        $addToBag.click();
      }
    }
  });
};
var updateSizeToDb = function updateSizeToDb($el, $saveSizeTrigger, $saveSizeMenu, opts, sizeValue) {
  var saveSize = $el.data('saveSize');
  if (sizeValue && saveSize) {
    var updateSizePath = opts.updateSizePath,
      code = opts.code;
    setLoading($el);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: "".concat(updateSizePath).concat(sizeValue),
      type: "POST",
      success: function success(ret) {
        removeLoading($el);
        if (ret.success) {
          closeSizes($el, $saveSizeMenu, opts);
          var $preorderCta = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#preorder-cta-".concat(code));
          var $addToBagCta = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-cta-".concat(code));
          var $addToBagBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBag_".concat(code));
          var $outOfStockBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#outOfStock_".concat(code));
          if ($outOfStockBtn.length) {
            $addToBagBtn.show();
            $outOfStockBtn.remove();
          }
          if (ret.isPreorder) {
            $preorderCta.show();
            $addToBagCta.hide();
          } else {
            $preorderCta.hide();
            $addToBagCta.show();
          }
          showConfirmation($saveSizeTrigger, opts, false);
          if (typeof logEngagementWithDetails === "function") {
            logEngagementWithDetails(window.location.href, 'favorites save your size', 'SaveSize', "size=".concat(sizeValue, ", code=").concat(code));
          }
        }
      }
    });
  } else {
    closeSizes($el, $saveSizeMenu, opts);
  }
};
var setClickCloseListener = function setClickCloseListener($el, $saveSizeTrigger, $saveSizeMenu, opts) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click.close', function (e) {
    var $sizeMenu = $el.find('.js-select-size-menu');
    var notSizeMenu = !$sizeMenu.is(e.target);
    var notSizeOption = $sizeMenu.has(e.target).length === 0;
    var notTriggerBtn = e.target !== $saveSizeTrigger[0];
    if (notSizeMenu && notSizeOption && notTriggerBtn) {
      closeSizes($el, $saveSizeMenu, opts);
    }
  });
};
var getSizes = function getSizes($el, $saveSizeTrigger, opts, isKey) {
  var sizePath = opts.sizePath;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-select-size-menu").remove();
  opts.addToBag = $saveSizeTrigger.data('addToBag');
  $saveSizeTrigger.data('addToBag', 'false');
  setLoading($el);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: "".concat(sizePath),
    type: "GET",
    success: function success(sizePopupMarkup) {
      removeLoading($el);
      $saveSizeTrigger.after(sizePopupMarkup);
      var $saveSizeMenu = $el.find(SS_MENU_CLASS);
      openSizes($el, $saveSizeTrigger, $saveSizeMenu, opts);
      if (!isKey) {
        setUpdateSizeListener($el, $saveSizeTrigger, $saveSizeMenu, isKey, opts);
      }
    }
  });
};

/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, $saveSizeTrigger, opts) {
  $el.on('keydown', function (evt) {
    keydownHandler($el, evt, $saveSizeTrigger, opts, true);
  });
  $saveSizeTrigger.on('click', function (evt) {
    evt.preventDefault();
    getSizes($el, $saveSizeTrigger, opts, false);
  });
  $saveSizeTrigger.on('keydown', function (evt) {
    preventHash(evt, $saveSizeTrigger);
  });
};

/**
 * Initializes sizeSelection.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelection
 * @see DEFAULTS
 */
function sizeSelection(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $saveSizeTrigger = $el.find(SS_TRIGGER_CLASS);
  setEventListeners($el, $saveSizeTrigger, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, sizeSelection);

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styleguide_src_assets_lib_props__ = __webpack_require__(78);



var VISUAL_NAV_JS = 'js-visual-nav';
var ATTRIBUTE_CLASS = 'visual-nav__attr';
var ATTRIBUTE_ITEM_CLASS = 'visual-nav__attr-item';
var ATTRIBUTE_LIST_BUTTON_CLASS = 'visual-nav__attr-list-button';
var ATTRIBUTE_BUTTON_CLASS = 'visual-nav__attr-button';
var ATTRIBUTE_ITEM_ACTIVE_CLASS = 'visual-nav__attr-item--active';
var ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS = 'visual-nav__attr-list-button--active';
var ATTRIBUTE_CONTAINERS_CLASS = 'visual-nav__attrs';
var ATTRIBUTE_BUTTON_SELECTED_CLASS = 'visual-nav__attr-button--selected';

//AB Test - 1028 Remove Fade-In UX-20295
var ATTRIBUTE_ITEM_ACTIVE_NO_FADE = 'visual-nav__attr-item--active-no-fade';
var ATTRIBUTE_ITEM_CLASS_NO_FADE = 'visual-nav__attr-item-no-fade';
var isNoFade = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styleguide_src_assets_lib_props__["a" /* get */])('visualNav.noFadeIn', false);
var getAttributesId = function getAttributesId(attributeGroupName) {
  return "#visual-nav-attrs-".concat(attributeGroupName);
};
var animateInAttributes = function animateInAttributes($activeAttributeItems) {
  var animationDelay = 80;
  $activeAttributeItems.each(function animationOfAttributes(i) {
    var _this = this;
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(_this).addClass(ATTRIBUTE_ITEM_ACTIVE_CLASS);
    }, animationDelay * i);
  });
};
var showAttributesById = function showAttributesById(id) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(ATTRIBUTE_ITEM_ACTIVE_CLASS)).removeClass(ATTRIBUTE_ITEM_ACTIVE_CLASS);
  var $activeAttributeContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(id);
  var $activeAttributeItems = $activeAttributeContainer.find(".".concat(ATTRIBUTE_ITEM_CLASS));
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(ATTRIBUTE_CONTAINERS_CLASS)).hide();
  $activeAttributeContainer.show();

  //AB Test - 1028 Remove Fade-In UX-20295
  if (isNoFade) {
    var $activeAttributeItemsNoFade = $activeAttributeContainer.find(".".concat(ATTRIBUTE_ITEM_CLASS_NO_FADE));
    $activeAttributeItemsNoFade.addClass("".concat(ATTRIBUTE_ITEM_ACTIVE_NO_FADE));
  } else {
    animateInAttributes($activeAttributeItems);
  }
};
var highlightAttributeGroupItem = function highlightAttributeGroupItem($el) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS)).removeClass(ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS);
  $el.addClass(ATTRIBUTE_LIST_ITEM_BUTTON_ACTIVE_CLASS);
};
var scrollAllAttributesToLeft = function scrollAllAttributesToLeft() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(ATTRIBUTE_CLASS)).scrollLeft(0);
};
function updateUiFromAvailableLabels(availableLabels) {
  var $attributeButtons = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.visual-nav__attr-button');
  var $attributeGroupButtons = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.visual-nav__attr-list-button');

  // Update Attribute Buttons
  $attributeButtons.each(function (i, attributeEl) {
    var $attribute = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(attributeEl);
    var attributeName = $attribute.data('attr');
    var isAvailable = availableLabels.includes(attributeName);
    if (isAvailable) {
      $attribute.attr('disabled', false);
    } else {
      $attribute.attr('disabled', true);
    }
  });
  function hasEnabledAttribute($attributes) {
    var result = false;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each($attributes, function (key, el) {
      if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).attr('disabled') === undefined) {
        result = true;
        // This will only exit the anonymous function and
        // stop the iteration immediately.
        return false;
      }
      return true;
    });

    // This will exit the function with return true;
    return result;
  }

  // Update Attribute List Buttons
  $attributeGroupButtons.each(function (i, attributeGroupEl) {
    var $attributeGroupButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(attributeGroupEl);
    var $attributesContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#visual-nav-attrs-".concat($attributeGroupButton.data('name')));
    var $attributes = $attributesContainer.find('.visual-nav__attr-button');
    var enabled = hasEnabledAttribute($attributes);
    if (enabled) {
      $attributeGroupButton.attr('disabled', false);
    } else {
      $attributeGroupButton.attr('disabled', true);
    }
  });
}

/**
 * Renders the state of attr buttons based on the selected class
 * @param {jQuery} $attributeButtons - attr buttons of a particular filter.
 */
var renderStateAttributeButtons = function renderStateAttributeButtons($attributeButtons) {
  $attributeButtons.each(function renderStateAttributeButton() {
    var $attributeButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var isAttributeSelected = $attributeButton.hasClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
    if (isAttributeSelected === true) {
      var imgSelected = $attributeButton.data('img-selected');
      $attributeButton.find('img').attr('src', imgSelected);
    } else {
      var img = $attributeButton.data('img');
      $attributeButton.find('img').attr('src', img);
    }
  });
};
var updateAttributeListCounter = function updateAttributeListCounter($attributeButton) {
  var $attributeContainer = $attributeButton.parents('.visual-nav__attrs');
  var attributeGroupButtonId = $attributeContainer.attr('id');
  var attributeSelected = $attributeContainer.find(".".concat(ATTRIBUTE_BUTTON_SELECTED_CLASS));
  var attributeSelectedCount = attributeSelected.length;
  var $attributeGroupButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("[aria-controls=\"".concat(attributeGroupButtonId, "\"]"));
  var $attributeGroupTextContainer = $attributeGroupButton.find('.visual-nav__attr-list-text');
  var $counter = $attributeGroupTextContainer.find('.visual-nav__attr-list-counter');
  if (attributeSelectedCount === 0) {
    $counter.remove();
    return;
  }
  if ($counter.length === 0) {
    $attributeGroupTextContainer.append("<span class=\"visual-nav__attr-list-counter\">(".concat(attributeSelectedCount, ")</span>"));
  } else {
    $counter.text("(".concat(attributeSelectedCount, ")"));
  }
};

/**
 * Reset Aria Attributes
 * @param  {jQuery} $listButtons - the top level list buttons
 */
var resetAriaAttributes = function resetAriaAttributes($listButtons) {
  $listButtons.each(function (key, listButton) {
    var $listButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(listButton);
    $listButton.attr('aria-selected', false);
  });
};

/**
 * Sets Aria Attributes for newly selected list button
 * @param  {jQuery} $selectedButton - selected list button
 */
var setAriaAttributes = function setAriaAttributes($selectedButton) {
  $selectedButton.attr('aria-selected', true);
};

/**
 * Arrow Handler
 * @param  {string} direction - direction of focus, next or previous el
 * @param  {jQuery} $focusedEl - el currently in focus
 * @param  {jQuery} $siblings - list of focusable elements
 */
var arrowHandler = function arrowHandler(direction, $focusedEl, $siblings) {
  var currentIndex = $siblings.index($focusedEl);
  var targetIndex;
  // hit right arrow on the last element, focus goes to the first in the list
  if (currentIndex === $siblings.length - 1 && direction === 'next') {
    targetIndex = 0;
    // hit left arrow on the first element, focus goes to the last in the list
  } else if (currentIndex === 0 && direction === 'prev') {
    targetIndex = $siblings.length - 1;
  } else {
    targetIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
  }
  $siblings[targetIndex].focus();
};

/**
 * Keydown Handler
 * @param  {event} evt - key event
 * @param  {jQuery} $visualNav - visual nav module
 */
var handleKeydown = function handleKeydown(evt, $visualNav) {
  var $currentFocusedEl = $visualNav.find(':focus');
  var isGroupButton = $currentFocusedEl.hasClass(ATTRIBUTE_LIST_BUTTON_CLASS);
  var isEscape = __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__["a" /* default */].keys.ESCAPE;
  var isNextArrows = __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ARROWRIGHT' || __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ARROWDOWN';
  var isPrevArrows = __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ARROWLEFT' || __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__["a" /* default */].parseKey(evt) === 'ARROWUP';

  // Group Item keyboard listeners
  if (isGroupButton) {
    var $groupButtons = $visualNav.find(".".concat(ATTRIBUTE_LIST_BUTTON_CLASS));
    if (isNextArrows) {
      arrowHandler('next', $currentFocusedEl, $groupButtons);
    }
    if (isPrevArrows) {
      arrowHandler('prev', $currentFocusedEl, $groupButtons);
    }
  }

  // Attribute keyboard listeners
  if (!isGroupButton) {
    var $attributeButtons = $visualNav.find(".".concat(ATTRIBUTE_ITEM_ACTIVE_CLASS, " .").concat(ATTRIBUTE_BUTTON_CLASS));
    if (isEscape) {
      // use data-parent-hash to move focus to parent list button
      var parentID = $currentFocusedEl.data('parent-hash');
      var $parentListItem = $visualNav.find("[aria-controls=\"visual-nav-attrs-".concat(parentID, "\"]"));
      $parentListItem.focus();
    }
    if (isNextArrows) {
      arrowHandler('next', $currentFocusedEl, $attributeButtons);
    }
    if (isPrevArrows) {
      arrowHandler('prev', $currentFocusedEl, $attributeButtons);
    }
  }
};
var findFirstFocusableAttribute = function findFirstFocusableAttribute($listButton, $visualNav) {
  var controlValue = $listButton.attr('aria-controls');
  var $targetPanel = $visualNav.find("#".concat(controlValue));
  var $targetAttribute = __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__["a" /* default */].findFocusable($targetPanel).eq(0);
  $targetAttribute.focus();
};
var handleAttributeClick = function handleAttributeClick($attributeButton, doSearch) {
  var $attributeContainer = $attributeButton.parents('.visual-nav__attrs');
  var selectedBehavior = $attributeContainer.data('select-behavior');
  var $attributeButtons = $attributeContainer.find('.visual-nav__attr-button');
  var isAttributeSelected = $attributeButton.hasClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
  if (selectedBehavior === 'single') {
    // Remove selected state from all attr buttons
    $attributeButtons.removeClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
  }

  // Toggle class of clicked attr button
  if (isAttributeSelected) {
    $attributeButton.removeClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
    $attributeButton.attr('aria-pressed', 'false');
  } else {
    $attributeButton.addClass(ATTRIBUTE_BUTTON_SELECTED_CLASS);
    $attributeButton.attr('aria-pressed', 'true');
  }
  renderStateAttributeButtons($attributeButtons);
  updateAttributeListCounter($attributeButton);
  if (doSearch) {
    window.doVisualSearch(1);
  }
};
var lazyLoadImagesById = function lazyLoadImagesById(id) {
  var images = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(id).find('[data-vn-lazy]');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each(images, function (index, image) {
    var $image = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(image);
    $image.attr('src', $image.data('vn-lazy'));
    $image.removeAttr('data-vn-lazy');
  });
};
var handleAttributeGroupClick = function handleAttributeGroupClick($el) {
  var attributeGroupName = $el.data('name');
  var id = getAttributesId(attributeGroupName);
  highlightAttributeGroupItem($el);
  showAttributesById(id);
  scrollAllAttributesToLeft();
  lazyLoadImagesById(id);
};
var addEventsToAttributeGroupButtons = function addEventsToAttributeGroupButtons($attributeGroupButtons, $visualNav) {
  $attributeGroupButtons.on('click', function attributeGroupButtonsHandleClick() {
    handleAttributeGroupClick(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
    resetAriaAttributes($attributeGroupButtons);
    setAriaAttributes(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
    findFirstFocusableAttribute(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), $visualNav);
  });
};
var addEventsToAttributeButtons = function addEventsToAttributeButtons($visualNav) {
  $visualNav.on('click', ".".concat(ATTRIBUTE_BUTTON_CLASS), function attributeButtonHandleClick() {
    handleAttributeClick(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), true);
  });
};
function init() {
  var $visualNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(VISUAL_NAV_JS));
  var $attributeGroupButtons = $visualNav.find(".".concat(ATTRIBUTE_LIST_BUTTON_CLASS));
  handleAttributeGroupClick($attributeGroupButtons.first());
  addEventsToAttributeGroupButtons($attributeGroupButtons, $visualNav);
  addEventsToAttributeButtons($visualNav);
  $visualNav.on('keydown.visualnav', function (evt) {
    handleKeydown(evt, $visualNav);
  });
}
init();
window.visualNav = {
  updateUiFromAvailableLabels: updateUiFromAvailableLabels,
  handleAttributeClick: handleAttributeClick,
  handleAttributeGroupClick: handleAttributeGroupClick
};

/***/ }),

/***/ 311:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_filter_count__ = __webpack_require__(190);
/**
 * Sidebar product filter search
 * Used for designer filter search on PLP
 * @module productFilterSearch
 */






var PLUGIN_NAME = 'productFilterSearch';
var DEFAULTS = {
  zeroResultsText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.filter.zeroResults', 'There are 0 results. Try a new search.')
};
var findMatches = function findMatches(phraseToMatch, list) {
  return list.filter(function (item) {
    var regex = new RegExp(phraseToMatch, 'ig');
    return item.value.match(regex);
  }).map(function (item) {
    return item.index;
  });
};
var createData = function createData($checkboxes) {
  return $checkboxes.toArray().map(function (checkbox, index) {
    // $(checkbox).data('originalValue', checkbox.data('filterValue'));
    return {
      value: String(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).data('filterValue')),
      index: index
    };
  });
};
var highlightText = function highlightText(phraseToMatch, text) {
  var regex = new RegExp(phraseToMatch, 'ig');
  return text.replace(regex, function (match) {
    return "<strong>".concat(match, "</strong>");
  });
};
var createZeroResults = function createZeroResults($container, _ref) {
  var zeroResultsText = _ref.zeroResultsText;
  var $zeroResults = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<p class='u-hide'>".concat(zeroResultsText, "</p>"));
  $container.find('#designer-search').closest('.field').after($zeroResults);
  return $zeroResults;
};
var countVisible = function countVisible($checkboxes) {
  return $checkboxes.filter(':visible').length;
};
var checkZeroResults = function checkZeroResults($checkboxes, $zeroResults) {
  if (countVisible($checkboxes) === 0) {
    $zeroResults.removeClass('u-hide');
  } else {
    $zeroResults.addClass('u-hide');
  }
};

/**
 * Initializes productFilterSearch
 * @param {HTMLElement} el - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterSearch(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $checkboxes = $container.find('input[type="checkbox"]');
  var checkboxData = createData($checkboxes);
  var $searchField = $container.find('input[type="text"');
  var $zeroResults = createZeroResults($container, opts);
  $container.productFilterCount();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[aria-controls=alldesigners]').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#alldesigners').formField();
  });
  $searchField.on('input', function () {
    var matches = findMatches($searchField.val(), checkboxData);
    $checkboxes.each(function (index, checkbox) {
      var $checkbox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox);
      var $checkboxContainer = $checkbox.closest('[data-product-search-container]');
      var $label = $checkboxContainer.find('.checkbox__label');

      // show checkbox option
      if (matches.includes(index)) {
        $checkboxContainer.removeClass('u-hide');
        if ($searchField.val() === '') {
          $label.html($checkbox.data('filterValue'));
        } else {
          var highlight = highlightText($searchField.val(), $checkbox.data('filterValue'));
          $label.html(highlight);
        }

        //  hide checkbox option
      } else {
        $checkboxContainer.addClass('u-hide');
      }
    });
    checkZeroResults($checkboxes, $zeroResults);
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterSearch);

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__visual_nav__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_product_filter_search__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plp_lazy_load__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__size_selection__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__add_to_bag__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__notify_me__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filter_search__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filter_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__filter_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_revieve_try_on__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_revieve_makeup_advisor__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_social_proof__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_add_to_bag__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__loyalty_favorites__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_throttle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_throttle__);















window.revieveTryOn = __WEBPACK_IMPORTED_MODULE_9__modules_revieve_try_on__["b" /* revieveTryOn */];
window.initPlpLazyLoad = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-lazy-load').plpLazyLoad({
    sessionName: 'plpSessionData',
    loadAfterCallback: function loadAfterCallback() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-image').lazy({
        bind: "event",
        effect: "fadeIn",
        threshold: 1500
      });
      if (window.bindHeartEvent) {
        window.bindHeartEvent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-favorite-button'));
      }
      if (window.bindColorSwatchEvent) {
        window.bindColorSwatchEvent();
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-select-size').sizeSelection();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-add-to-bag').plpAddToBag();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notify-me').plpNotifyMe();
      if (window.rcProps.revieveEventEnabled) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__modules_revieve_try_on__["b" /* revieveTryOn */])({
          isPlp: true,
          checkAvailability: true
        });
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-video').each(function () {
        this.play();
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__modules_revieve_makeup_advisor__["a" /* revieveMakeupAdvisor */])();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__modules_social_proof__["b" /* renderPlpSocialProof */])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-container').toArray().map(function (el) {
        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).prop('id');
      }));
      if (window.rcProps.zeligWidgetLoaded) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-zelig-try-on').removeClass('u-hide');
      }
    }
  });
};
window.initRemoveFromFavListHandler = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-remove-from-fav-list').on('click', function () {
    var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var description = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('description');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#undo-remove-link').data('id', $this.data('listid')).data('code', $this.data('code'));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: "/content/favorites/mylist/removeproduct/" + $this.data('listid') + "/" + $this.data('code'),
      type: "POST",
      success: function success() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-removed-item-title').text(description);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          open: "removed-item-notification",
          type: "notification",
          triggerOpen: true,
          onOpen: function onOpen() {
            $this.parents('.js-plp-container').hide();
            var count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#filtered_fav_count').data('count');
            var newCount = count - 1;
            var text = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#filtered_fav_count').text();
            text = text.replace(count, newCount);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#filtered_fav_count').text(text).data('count', newCount);
            if (newCount == 0) {
              window.location.reload();
            }
          }
        });
      }
    });
  });
};
window.initPlpCtas = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-select-size').sizeSelection();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-add-to-bag').plpAddToBag();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notify-me').plpNotifyMe();
};

// Requires for Zelig Add to Cart integration
window.addToBagWithData = __WEBPACK_IMPORTED_MODULE_12__modules_add_to_bag__["a" /* addToBagWithData */];
window.initVisualNavLeftNavImages = function () {
  var $vnColors = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-vn-color');
  $vnColors.each(function (unused, el) {
    var $input = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var inputId = $input.attr('id');
    var activeIconPath = $input.data('activeIcon');
    var inactiveIconPath = $input.data('inactiveIcon');
    vnImageChangeHelper($input.is(':checked'), inputId, activeIconPath, inactiveIconPath);
    $input.on('change', function () {
      vnImageChangeHelper($input.is(':checked'), inputId, activeIconPath, inactiveIconPath);
    });
  });
};
function vnImageChangeHelper(isChecked, inputId, activeIconPath, inactiveIconPath) {
  if (isChecked) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("label[for='".concat(inputId, "']")).css('background-image', "url(".concat(activeIconPath, ")"));
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("label[for='".concat(inputId, "']")).css('background-image', "url(".concat(inactiveIconPath, ")"));
  }
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  initPlpLazyLoad();
  initPlpCtas();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-search').productFilterSearch();

  /*
   * Favorites PLP - removing item from list
   */
  initRemoveFromFavListHandler();

  /*
   * Favorites PLP - edit favorite list name
   */

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-edit-fav-list-name').on('click', function () {
    var listID = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('id');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: '/content/favorites/mylist/popupMarkup/renameList?listName=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('listname')),
      type: 'small',
      triggerOpen: true,
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-edit-fav-list-name-form').on('submit', function (e) {
          e.preventDefault();
          var errorMsg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#rename-error-msg');
          var $listNameInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#list-name');
          var $listNameField = $listNameInput.closest('.field');
          $listNameField.removeClass('is-error');
          var newName = $listNameInput.val();
          if (newName.trim() !== "") {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
              url: "/content/favorites/mylist/rename/" + listID + "?newName=" + encodeURIComponent(newName),
              type: "POST",
              success: function success(listData) {
                $listNameField.removeClass('is-error');
                if (listData.errorMessage) {
                  errorMsg.html(listData.errorMessage);
                  $listNameField.addClass('is-error');
                } else {
                  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
                  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                    open: 'list-name-updated-notification',
                    type: 'notification',
                    triggerOpen: true
                  });
                  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#listName").text(newName);
                  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-left-nav-container').find('a.active').text(newName).attr('title', newName);
                  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-delete-fav-list').data('listname', newName);
                }
              }
            });
          } else {
            errorMsg.html('Please enter a list name.');
            $listNameField.addClass('is-error');
          }
        });
      }
    });
  });

  /*
  * GRLFRND PLP AB Test - Scroll to Products
  */
  var scrollToID = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#jump-to-products');
  if (scrollToID.length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').css({
      'scroll-behavior': 'smooth',
      'scroll-padding-top': '10rem'
    });
  }

  /*
   * Favorites PLP - delete favorite list
   */

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-delete-fav-list').on('click', function () {
    var listID = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('id');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: '/content/favorites/mylist/popupMarkup/deleteListConfirm?listName=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('listname')),
      type: 'small',
      triggerOpen: true,
      onComplete: function onComplete() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-delete-fav-list-form').on('submit', function (e) {
          e.preventDefault();
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
            url: '/content/favorites/mylist/delete/' + listID,
            type: 'POST',
            success: function success() {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close();
              __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                open: 'list-deleted-notification',
                type: 'notification',
                triggerOpen: true
              });
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-left-nav-container').find('a.active').remove();
              if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-left-nav-container').find('.ui-list>li>a').length) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-left-nav-container').find('.ui-list>li>a')[0].click();
              } else {
                window.location.href = "/content/favorites/mylist/";
              }
            }
          });
        });
      }
    });
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#undo-remove-link').on('click', function () {
    var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: "/content/favorites/mylist/addproduct/" + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('id') + "/" + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code'),
      type: "POST",
      success: function success() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + code).show();
        var count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#filtered_fav_count').data('count');
        var text = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#filtered_fav_count').text();
        text = text.replace(count, count + 1);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#filtered_fav_count').text(text).data('count', count + 1);
      }
    });
  });

  /*
   * Fit Predictor adding tabbing capabilities
   */
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fp-root .fp-cta').attr('tabindex', 0);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('revieveScriptLoaded', function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__modules_revieve_try_on__["b" /* revieveTryOn */])({
      isPlp: true,
      checkAvailability: !__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-lazy-load').length
    });
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__modules_revieve_try_on__["a" /* revieveAddToBag */])();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('click.textSwitch', '.js-text-switch-trigger', function () {
    var isActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('is-active');

    // Get custom text from data attributes, with fallbacks
    var activeText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('active-text');
    var inactiveText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('inactive-text');
    if (!isActive) {
      // Change to active state
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('is-active');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('pill-button--black');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('pill-button--white-blk-stroke');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.js-toggle-icon').removeClass('u-hide');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.js-button-text-target').text(activeText);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('is-active', true);
    } else {
      // Revert back to inactive state
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('is-active');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('pill-button--black');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('pill-button--white-blk-stroke');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.js-toggle-icon').addClass('u-hide');
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.js-button-text-target').text(inactiveText);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('is-active', false);
    }
  });
  initVisualNavLeftNavImages();
});
document.addEventListener("DOMContentLoaded", function () {
  // Create the observer with the throttled callback
  var observer = new MutationObserver(__WEBPACK_IMPORTED_MODULE_14_lodash_throttle___default()(function (mutationsList, observer) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* checkAndHideZeroReviewElements */])();
  }, 20));

  // Start observing with appropriate options
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initial check
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* checkAndHideZeroReviewElements */])();
});
document.addEventListener('zeligWidgetLoaded', function (e) {
  window.rcProps.zeligWidgetLoaded = true;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-zelig-try-on').removeClass('u-hide');
});
document.addEventListener('WidgetModalOpen', function (e) {
  logEngagement(window.location.href, 'Zelig', 'PLP widget clicks');
});

/***/ })

},[334]);


// WEBPACK FOOTER //
// dist/plp.js